import { graphql } from 'gql';

export const bimWorkOrderOthersGql = graphql(`
    query bimWorkOrderOthers(
        $skip: Int
        $take: Int
        $workOrderId: Long!
        $constructionTypeId: Int!
        $where: BimWorkOrderOtherDataFilterInput
        $order: [BimWorkOrderOtherDataSortInput!]
    ) {
        bimWorkOrderOthers(
            skip: $skip
            take: $take
            workOrderId: $workOrderId
            constructionTypeId: $constructionTypeId
            where: $where
            order: $order
        ) {
            totalCount
            items {
                contractOtherCostId
                name
                calculatingType
                calculatingTypeValue
                chapter
                section
                status
                costLimit
                totalRemainderCost
                deviation
            }
        }
    }
`);

export const bimWorkOrderOtherForActGql = graphql(`
    query bimWorkOrderOtherForAct(
        $order: [BimWorkOrderOtherDataSortInput!]
        $skip: Int
        $take: Int
        $where: BimWorkOrderOtherDataFilterInput
        $workOrderObjectId: Long!
    ) {
        bimWorkOrderOtherForAct(
            skip: $skip
            take: $take
            where: $where
            order: $order
            workOrderObjectId: $workOrderObjectId
        ) {
            totalCount
            items {
                contractOtherCostId
                name
                calculatingType
                calculatingTypeValue
                chapter
                section
                status
                costLimit
                totalRemainderCost
                deviation
            }
        }
    }
`);

export const bimAddWorkOrderOthersGql = graphql(`
    mutation bimAddWorkOrderOthers($contractType: ProjectContractTypeEnum!, $input: BimWorkOrderOtherInput!) {
        bimAddWorkOrderOthers(contractType: $contractType, input: $input) {
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
            data {
                itemIds
                isWorkOrderChangeRequired
            }
        }
    }
`);

export const bimAddWorkOrderOtherForActGql = graphql(`
    mutation bimAddWorkOrderOtherForAct($contractOtherCostIds: [Long!]!, $workOrderObjectId: Long!) {
        bimAddWorkOrderOtherForAct(contractOtherCostIds: $contractOtherCostIds, workOrderObjectId: $workOrderObjectId) {
            data {
                itemIds
                workOrderId
                isWorkOrderChangeRequired
                itemIds
            }
            result
            message
            code
            actionRequired
            validation {
                property
                message
                metadata
            }
        }
    }
`);
